<div bsModal #GenericProgress="bs-modal" class="modal  fade" tabindex="-1" role="dialog"
  aria-labelledby="GenericProgress" aria-hidden="true" [config]="{backdrop: 'static'}">
  <!-- <div class="modal-dialog modal-lg modalCenter">
        <div class="col-5 m-auto modal-content pb-4 pl-4 pr-4 pt-3">

            <div class="text-center">

                <img src="../../../../assets/accounts/importAccounts/data-transfer.svg" /><br /><br />
                <h6 class="font-weight-bold"> {{progressHeader}}</h6>
                <h6> {{ProgressDetail}}</h6>
                <h6 *ngIf="progress>=0"> {{progress}}%</h6> 
                <div class="mt-3 progress">
                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': progress + '%' }"></div>
                </div> 
            </div>
        </div>
    </div> -->



  <div class="upload-modal modal-dialog modal-lg modalCenter">
    <div class="modal-content upload-modal">
      <div class="modal-header font-weight-bold">
        <img class="modal-icon pr-2" src="../../../../assets/accounts/importAccounts/Vector.png" />
        <span class="modal-title pt-2">{{progressHeader}}</span>
        <span class="modal-close" (click)="askToClose()">✕</span>
      </div>


      <div *ngIf="_folder_details">
        <div class="folder-info">
          <div class="folder-details w-100">
            <img src="../../../../assets/accounts/importAccounts/solar_folder-bold.png" class="folder-icon" />
            <div class="folder-name">{{ _folderName }}</div>
            <div class="folder-meta">{{ _totalFiles }} files &nbsp;&nbsp; {{ _totalSizeMB }} MB</div>
          </div>
        </div>


        <div class="mt-3 progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
            [style.width.%]="progress || 0" [attr.aria-valuenow]="progress || 0" aria-valuemin="0" aria-valuemax="100">
            {{ progress }}%
          </div>
        </div>

        <div class="folder-info">
          <div class="folder-details w-100">
            <div class="folder-name">
              <img src="../../../../assets/accounts/importAccounts/solar_folder-bold.png" class="folder-icon mb-1 mr-1"
                style="width: 18px ; height: 18px;" />
              Files uploaded : {{_uploadedFilesCount}} out of {{_totalFiles}}
            </div>
            <div class="folder-meta">
              <img src="../../../../assets/accounts/importAccounts/pajamas_timer.png" class="folder-icon mb-1 mr-1"
                style="width: 18px ; height: 18px;" />
              Remaining Time : " {{_estimatedRemainingTime}} min
            </div>
          </div>


        </div>
      </div>
      <div *ngIf="!_folder_details">
        <div class="mt-3 progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
            [style.width.%]="progress || 0" [attr.aria-valuenow]="progress || 0" aria-valuemin="0" aria-valuemax="100">
            {{ progress }}%
          </div>
        </div>

        <h6> {{ProgressDetail}}</h6>
      </div>


      <div class="modal-actions">
        <button class="cancleUpload-btn ml-3" (click)="askToClose()">Cancel</button>
      </div>
    </div>
  </div>
</div>